import { Check, X, Minus } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface ComparisonRow {
  feature: string;
  optionA: "yes" | "no" | "partial" | string;
  optionB: "yes" | "no" | "partial" | string;
}

interface ComparisonTableProps {
  optionAName: string;
  optionBName: string;
  rows: ComparisonRow[];
}

const renderValue = (value: "yes" | "no" | "partial" | string) => {
  if (value === "yes") return <Check className="h-5 w-5 text-primary mx-auto" />;
  if (value === "no") return <X className="h-5 w-5 text-destructive mx-auto" />;
  if (value === "partial") return <Minus className="h-5 w-5 text-muted-foreground mx-auto" />;
  return <span className="text-sm">{value}</span>;
};

export const ComparisonTable = ({ optionAName, optionBName, rows }: ComparisonTableProps) => {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[40%]">Feature</TableHead>
            <TableHead className="text-center">{optionAName}</TableHead>
            <TableHead className="text-center">{optionBName}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{row.feature}</TableCell>
              <TableCell className="text-center">{renderValue(row.optionA)}</TableCell>
              <TableCell className="text-center">{renderValue(row.optionB)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
